import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./PromoPopup.css";

const PromoPopup = ({ flyer }) => {
  const [show, setShow] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!flyer?.enabled) return;
    const timer = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(timer);
  }, [flyer, location.pathname]);

  if (!flyer?.enabled || !show) return null;

  const imageSrc =
    (process.env.REACT_APP_CDN_PATH || "") +
    "hotel/flordeindia/images/homepage/promotion-flyers/" +
    flyer.image?.filename +
    (flyer.lastUpdated ? `?v=${flyer.lastUpdated}` : "");

  const hasLink = !!flyer.image?.linkUrl;

  return (
    <div className="promo-popup-overlay">
      <div className="promo-popup-modal">
        <button
          className="promo-popup-close"
          onClick={() => setShow(false)}
          aria-label="Close"
        >
          ×
        </button>
        {!imgLoaded && <div className="promo-popup-placeholder" />}
        <img
          src={imageSrc}
          alt={flyer.image?.alt || "Special Offer"}
          className="promo-popup-image"
          style={imgLoaded ? { cursor: hasLink ? "pointer" : "default" } : { display: "none" }}
          onLoad={() => setImgLoaded(true)}
          onClick={hasLink ? () => window.open(flyer.image.linkUrl, "_blank") : undefined}
        />
      </div>
    </div>
  );
};

export default PromoPopup;
